import React from 'react';
import { Circle, G, Path } from 'react-native-svg';
import { Center, Icon } from 'native-base';

export interface IconProps {
  iconSize: number;
  color: string;
}

export function SettingsIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon size={iconSize} viewBox="0 0 36 35">
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M31.6653 15.2833L28.4083 14.3111C28.1832 13.5249 27.8735 12.7654 27.4847 12.0458L29.0792 9.0611C29.139 8.94843 29.1609 8.81948 29.1416 8.69339C29.1224 8.56729 29.063 8.45076 28.9722 8.3611L26.6486 6.02776C26.559 5.93703 26.4424 5.87762 26.3163 5.85835C26.1902 5.83908 26.0613 5.86099 25.9486 5.92082L22.9833 7.50554C22.2567 7.09785 21.4872 6.77179 20.6889 6.53332L19.7167 3.31526C19.6756 3.19667 19.5979 3.09418 19.4948 3.02255C19.3917 2.95092 19.2686 2.91384 19.1431 2.91665H15.857C15.7307 2.91724 15.6079 2.9581 15.5065 3.03329C15.4051 3.10848 15.3303 3.21408 15.2931 3.33471L14.3208 6.54304C13.5159 6.78024 12.7398 7.10633 12.007 7.51526L9.09029 5.94026C8.97763 5.88044 8.84868 5.85853 8.72258 5.87779C8.59648 5.89706 8.47995 5.95647 8.39029 6.04721L6.02779 8.35138C5.93705 8.44104 5.87764 8.55756 5.85838 8.68366C5.83911 8.80976 5.86102 8.93871 5.92085 9.05138L7.49585 11.968C7.08757 12.6978 6.7615 13.4706 6.52362 14.2722L3.30557 15.2444C3.18494 15.2817 3.07934 15.3565 3.00415 15.4579C2.92896 15.5593 2.8881 15.6821 2.88751 15.8083V19.0944C2.8881 19.2207 2.92896 19.3435 3.00415 19.4449C3.07934 19.5463 3.18494 19.6211 3.30557 19.6583L6.54307 20.6305C6.78354 21.4188 7.10956 22.1785 7.51529 22.8958L5.92085 25.9486C5.86102 26.0613 5.83911 26.1902 5.85838 26.3163C5.87764 26.4424 5.93705 26.5589 6.02779 26.6486L8.3514 28.9722C8.44106 29.0629 8.55759 29.1224 8.68369 29.1416C8.80979 29.1609 8.93874 29.139 9.0514 29.0792L12.0556 27.475C12.7662 27.8585 13.5159 28.1648 14.2917 28.3889L15.2639 31.6653C15.3012 31.7859 15.3759 31.8915 15.4774 31.9667C15.5788 32.0419 15.7015 32.0827 15.8278 32.0833H19.1139C19.2402 32.0827 19.3629 32.0419 19.4643 31.9667C19.5658 31.8915 19.6405 31.7859 19.6778 31.6653L20.65 28.3792C21.4192 28.1539 22.1623 27.8476 22.8667 27.4653L25.8903 29.0792C26.003 29.139 26.1319 29.1609 26.258 29.1416C26.3841 29.1224 26.5006 29.0629 26.5903 28.9722L28.9139 26.6486C29.0046 26.5589 29.0641 26.4424 29.0833 26.3163C29.1026 26.1902 29.0807 26.0613 29.0208 25.9486L27.407 22.9347C27.7933 22.2276 28.1029 21.4812 28.3306 20.7083L31.607 19.7361C31.7276 19.6988 31.8332 19.6241 31.9084 19.5226C31.9836 19.4212 32.0244 19.2985 32.025 19.1722V15.8569C32.0307 15.736 31.9994 15.6163 31.9351 15.5137C31.8708 15.4112 31.7766 15.3308 31.6653 15.2833ZM17.5 22.8472C16.4424 22.8472 15.4086 22.5336 14.5293 21.946C13.6499 21.3585 12.9645 20.5234 12.5598 19.5463C12.1551 18.5692 12.0492 17.4941 12.2555 16.4568C12.4619 15.4195 12.9711 14.4668 13.719 13.7189C14.4668 12.9711 15.4196 12.4618 16.4568 12.2555C17.4941 12.0492 18.5692 12.1551 19.5463 12.5598C20.5234 12.9645 21.3585 13.6499 21.9461 14.5292C22.5336 15.4086 22.8472 16.4424 22.8472 17.5C22.8472 18.9182 22.2839 20.2782 21.2811 21.281C20.2783 22.2838 18.9182 22.8472 17.5 22.8472Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function NotificationsActiveIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon size={iconSize} viewBox="0 0 36 35">
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M11.0542 5.94998L8.96875 3.86456C5.46875 6.53331 3.16459 10.6458 2.96042 15.3125H5.87709C5.98039 13.463 6.49954 11.6607 7.39589 10.0397C8.29224 8.4187 9.5427 7.02077 11.0542 5.94998ZM29.1229 15.3125H32.0396C31.8208 10.6458 29.5167 6.53331 26.0312 3.86456L23.9604 5.94998C25.4654 7.02604 26.7103 8.42552 27.6036 10.0457C28.497 11.6658 29.0161 13.4655 29.1229 15.3125ZM26.25 16.0416C26.25 11.5646 23.8583 7.81665 19.6875 6.82498V3.64581H15.3125V6.82498C11.1271 7.81665 8.75 11.55 8.75 16.0416V23.3333L5.83333 26.25V27.7083H29.1667V26.25L26.25 23.3333V16.0416ZM17.5 32.0833C17.7042 32.0833 17.8938 32.0687 18.0833 32.025C19.0312 31.8208 19.8042 31.1791 20.1833 30.3041C20.3292 29.9541 20.4021 29.575 20.4021 29.1666H14.5688C14.5833 30.7708 15.8813 32.0833 17.5 32.0833Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function NotificationsEmptyIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon size={iconSize} viewBox="0 0 36 35">
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M18 32.0833C19.6042 32.0833 20.9167 30.7708 20.9167 29.1666H15.0833C15.0833 29.9402 15.3906 30.6821 15.9376 31.229C16.4846 31.776 17.2265 32.0833 18 32.0833ZM26.75 23.3333V16.0416C26.75 11.5646 24.3583 7.81665 20.1875 6.82498V3.64581H15.8125V6.82498C11.6271 7.81665 9.25001 11.55 9.25001 16.0416V23.3333L6.33334 26.25V27.7083H29.6667V26.25L26.75 23.3333Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function DevicesIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon size={iconSize} viewBox="0 0 36 35">
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M29.6667 4.375H6.33332C5.55978 4.375 4.81791 4.68229 4.27093 5.22927C3.72395 5.77625 3.41666 6.51812 3.41666 7.29167V13.125C3.41666 13.8985 3.72395 14.6404 4.27093 15.1874C4.81791 15.7344 5.55978 16.0417 6.33332 16.0417H29.6667C30.4402 16.0417 31.1821 15.7344 31.7291 15.1874C32.276 14.6404 32.5833 13.8985 32.5833 13.125V7.29167C32.5833 6.51812 32.276 5.77625 31.7291 5.22927C31.1821 4.68229 30.4402 4.375 29.6667 4.375ZM22.375 11.6667H19.4583V8.75H22.375V11.6667ZM28.2083 11.6667H25.2917V8.75H28.2083V11.6667ZM29.6667 18.9583H6.33332C5.55978 18.9583 4.81791 19.2656 4.27093 19.8126C3.72395 20.3596 3.41666 21.1015 3.41666 21.875V27.7083C3.41666 28.4819 3.72395 29.2237 4.27093 29.7707C4.81791 30.3177 5.55978 30.625 6.33332 30.625H29.6667C30.4402 30.625 31.1821 30.3177 31.7291 29.7707C32.276 29.2237 32.5833 28.4819 32.5833 27.7083V21.875C32.5833 21.1015 32.276 20.3596 31.7291 19.8126C31.1821 19.2656 30.4402 18.9583 29.6667 18.9583ZM22.375 26.25H19.4583V23.3333H22.375V26.25ZM28.2083 26.25H25.2917V23.3333H28.2083V26.25Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function DashboardIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon size={iconSize} viewBox="0 0 36 35">
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M6.33333 18.9583H15.0833C15.4701 18.9583 15.841 18.8047 16.1145 18.5312C16.388 18.2577 16.5417 17.8868 16.5417 17.5V5.83333C16.5417 5.44656 16.388 5.07563 16.1145 4.80214C15.841 4.52865 15.4701 4.375 15.0833 4.375H6.33333C5.94656 4.375 5.57563 4.52865 5.30214 4.80214C5.02865 5.07563 4.875 5.44656 4.875 5.83333V17.5C4.875 17.8868 5.02865 18.2577 5.30214 18.5312C5.57563 18.8047 5.94656 18.9583 6.33333 18.9583ZM4.875 29.1667C4.875 29.5534 5.02865 29.9244 5.30214 30.1979C5.57563 30.4714 5.94656 30.625 6.33333 30.625H15.0833C15.4701 30.625 15.841 30.4714 16.1145 30.1979C16.388 29.9244 16.5417 29.5534 16.5417 29.1667V23.3333C16.5417 22.9466 16.388 22.5756 16.1145 22.3021C15.841 22.0286 15.4701 21.875 15.0833 21.875H6.33333C5.94656 21.875 5.57563 22.0286 5.30214 22.3021C5.02865 22.5756 4.875 22.9466 4.875 23.3333V29.1667ZM19.4583 29.1667C19.4583 29.5534 19.612 29.9244 19.8855 30.1979C20.159 30.4714 20.5299 30.625 20.9167 30.625H29.6667C30.0534 30.625 30.4244 30.4714 30.6979 30.1979C30.9714 29.9244 31.125 29.5534 31.125 29.1667V18.9583C31.125 18.5716 30.9714 18.2006 30.6979 17.9271C30.4244 17.6536 30.0534 17.5 29.6667 17.5H20.9167C20.5299 17.5 20.159 17.6536 19.8855 17.9271C19.612 18.2006 19.4583 18.5716 19.4583 18.9583V29.1667ZM20.9167 14.5833H29.6667C30.0534 14.5833 30.4244 14.4297 30.6979 14.1562C30.9714 13.8827 31.125 13.5118 31.125 13.125V5.83333C31.125 5.44656 30.9714 5.07563 30.6979 4.80214C30.4244 4.52865 30.0534 4.375 29.6667 4.375H20.9167C20.5299 4.375 20.159 4.52865 19.8855 4.80214C19.612 5.07563 19.4583 5.44656 19.4583 5.83333V13.125C19.4583 13.5118 19.612 13.8827 19.8855 14.1562C20.159 14.4297 20.5299 14.5833 20.9167 14.5833Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function ShiedCheckmarkIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon size={iconSize} viewBox="0 0 50 50">
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M25 0C22.8438 0 19.2406 0.828125 15.85 1.75C12.3813 2.6875 8.88439 3.79687 6.82814 4.46875C5.96843 4.75266 5.20624 5.27333 4.62913 5.97094C4.05203 6.66855 3.68341 7.51481 3.56564 8.4125C1.70314 22.4031 6.02502 32.7719 11.2688 39.6313C13.4925 42.5655 16.1439 45.1495 19.1344 47.2969C20.3406 48.15 21.4594 48.8031 22.4094 49.25C23.2844 49.6625 24.225 50 25 50C25.775 50 26.7125 49.6625 27.5906 49.25C28.7359 48.6933 29.8316 48.0399 30.8656 47.2969C33.8562 45.1495 36.5076 42.5656 38.7313 39.6313C43.975 32.7719 48.2969 22.4031 46.4344 8.4125C46.3168 7.51438 45.9483 6.66763 45.3712 5.96948C44.7941 5.27133 44.0318 4.75009 43.1719 4.46563C40.1869 3.48692 37.1787 2.5804 34.15 1.74688C30.7594 0.83125 27.1563 0 25 0ZM31.7063 16.0812C31.9997 15.7879 32.3976 15.623 32.8125 15.623C33.2274 15.623 33.6254 15.7879 33.9188 16.0812C34.2122 16.3746 34.377 16.7726 34.377 17.1875C34.377 17.6024 34.2122 18.0004 33.9188 18.2938L24.5438 27.6688C24.3986 27.8143 24.2262 27.9297 24.0364 28.0085C23.8465 28.0872 23.643 28.1278 23.4375 28.1278C23.232 28.1278 23.0285 28.0872 22.8387 28.0085C22.6488 27.9297 22.4764 27.8143 22.3313 27.6688L17.6438 22.9813C17.4985 22.836 17.3833 22.6635 17.3046 22.4737C17.226 22.2839 17.1855 22.0805 17.1855 21.875C17.1855 21.6695 17.226 21.4661 17.3046 21.2763C17.3833 21.0865 17.4985 20.914 17.6438 20.7687C17.789 20.6235 17.9615 20.5082 18.1513 20.4296C18.3411 20.351 18.5446 20.3105 18.75 20.3105C18.9555 20.3105 19.1589 20.351 19.3487 20.4296C19.5385 20.5082 19.711 20.6235 19.8563 20.7687L23.4375 24.3531L31.7063 16.0812Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function BackIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 20 18" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M18.75 7.74998H3.925L8.4625 2.29998C8.67467 2.04471 8.77675 1.71561 8.74628 1.38507C8.7158 1.05454 8.55527 0.749652 8.3 0.537478C8.04473 0.325305 7.71563 0.223228 7.3851 0.253702C7.05456 0.284177 6.74967 0.444708 6.5375 0.699979L0.2875 8.19998C0.245451 8.25963 0.207849 8.3223 0.175 8.38748C0.175 8.44998 0.175 8.48748 0.0875002 8.54998C0.0308421 8.6933 0.0011764 8.84587 0 8.99998C0.0011764 9.15409 0.0308421 9.30665 0.0875002 9.44998C0.0875002 9.51248 0.0874998 9.54998 0.175 9.61248C0.207849 9.67765 0.245451 9.74032 0.2875 9.79998L6.5375 17.3C6.65503 17.4411 6.8022 17.5546 6.96856 17.6323C7.13491 17.7101 7.31636 17.7503 7.5 17.75C7.79207 17.7505 8.07511 17.6488 8.3 17.4625C8.42657 17.3575 8.5312 17.2287 8.60789 17.0832C8.68458 16.9378 8.73183 16.7787 8.74692 16.6149C8.76202 16.4512 8.74466 16.2861 8.69586 16.1291C8.64705 15.9721 8.56775 15.8263 8.4625 15.7L3.925 10.25H18.75C19.0815 10.25 19.3995 10.1183 19.6339 9.88386C19.8683 9.64944 20 9.3315 20 8.99998C20 8.66846 19.8683 8.35052 19.6339 8.1161C19.3995 7.88167 19.0815 7.74998 18.75 7.74998Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function PlusIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 25 25" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M12.5 0C12.9144 0 13.3118 0.16462 13.6049 0.457646C13.8979 0.750671 14.0625 1.1481 14.0625 1.5625V10.9375H23.4375C23.8519 10.9375 24.2493 11.1021 24.5424 11.3951C24.8354 11.6882 25 12.0856 25 12.5C25 12.9144 24.8354 13.3118 24.5424 13.6049C24.2493 13.8979 23.8519 14.0625 23.4375 14.0625H14.0625V23.4375C14.0625 23.8519 13.8979 24.2493 13.6049 24.5424C13.3118 24.8354 12.9144 25 12.5 25C12.0856 25 11.6882 24.8354 11.3951 24.5424C11.1021 24.2493 10.9375 23.8519 10.9375 23.4375V14.0625H1.5625C1.1481 14.0625 0.750671 13.8979 0.457646 13.6049C0.16462 13.3118 0 12.9144 0 12.5C0 12.0856 0.16462 11.6882 0.457646 11.3951C0.750671 11.1021 1.1481 10.9375 1.5625 10.9375H10.9375V1.5625C10.9375 1.1481 11.1021 0.750671 11.3951 0.457646C11.6882 0.16462 12.0856 0 12.5 0V0Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function CheckMarkIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 25 25" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M25 12.5C25 15.8152 23.683 18.9946 21.3388 21.3388C18.9946 23.683 15.8152 25 12.5 25C9.18479 25 6.00537 23.683 3.66117 21.3388C1.31696 18.9946 0 15.8152 0 12.5C0 9.18479 1.31696 6.00537 3.66117 3.66117C6.00537 1.31696 9.18479 0 12.5 0C15.8152 0 18.9946 1.31696 21.3388 3.66117C23.683 6.00537 25 9.18479 25 12.5ZM18.7969 7.76562C18.6853 7.6544 18.5524 7.56683 18.4061 7.50815C18.2599 7.44946 18.1033 7.42087 17.9458 7.42408C17.7883 7.42729 17.633 7.46223 17.4893 7.52683C17.3456 7.59142 17.2164 7.68433 17.1094 7.8L11.6828 14.7141L8.4125 11.4422C8.19035 11.2352 7.89653 11.1225 7.59293 11.1279C7.28934 11.1332 6.99967 11.2562 6.78497 11.4709C6.57026 11.6856 6.44727 11.9753 6.44191 12.2789C6.43656 12.5825 6.54925 12.8763 6.75625 13.0984L10.8906 17.2344C11.002 17.3456 11.1346 17.4332 11.2806 17.492C11.4266 17.5508 11.5829 17.5796 11.7402 17.5767C11.8976 17.5737 12.0527 17.5392 12.1964 17.475C12.3401 17.4108 12.4694 17.3184 12.5766 17.2031L18.8141 9.40625C19.0267 9.18515 19.1442 8.88949 19.1413 8.58275C19.1383 8.276 19.0153 7.98263 18.7984 7.76562H18.7969Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function XIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 23 23" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M2.49991 2.5C2.72261 2.2773 3.02465 2.15219 3.3396 2.15219C3.65454 2.15219 3.95659 2.2773 4.17929 2.5L11.5 9.82063L18.8206 2.50001C19.0433 2.27731 19.3454 2.1522 19.6603 2.1522C19.9752 2.1522 20.2773 2.27731 20.5 2.50001C20.7227 2.72271 20.8478 3.02476 20.8478 3.3397C20.8478 3.65465 20.7227 3.95669 20.5 4.17939L13.1794 11.5L20.5 18.8206C20.7227 19.0433 20.8478 19.3454 20.8478 19.6603C20.8478 19.9753 20.7227 20.2773 20.5 20.5C20.2773 20.7227 19.9753 20.8478 19.6603 20.8478C19.3454 20.8478 19.0433 20.7227 18.8206 20.5L11.5 13.1794L4.17938 20.5C3.95668 20.7227 3.65464 20.8478 3.33969 20.8478C3.02475 20.8478 2.7227 20.7227 2.5 20.5C2.2773 20.2773 2.15219 19.9753 2.15219 19.6603C2.15219 19.3454 2.2773 19.0433 2.5 18.8206L9.82061 11.5L2.49991 4.17938C2.27721 3.95668 2.1521 3.65464 2.1521 3.33969C2.1521 3.02475 2.27721 2.7227 2.49991 2.5Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function OfflineIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 25 25" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M12.5 0C5.6 0 0 5.6 0 12.5C0 19.4 5.6 25 12.5 25C19.4 25 25 19.4 25 12.5C25 5.6 19.4 0 12.5 0ZM18.75 13.75H6.25V11.25H18.75V13.75Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function QRIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 30 30" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M10.8214 16.2857C11.5886 16.2857 12.3244 16.5905 12.867 17.133C13.4095 17.6756 13.7143 18.4114 13.7143 19.1786V26.25C13.7143 27.0173 13.4095 27.7531 12.867 28.2956C12.3244 28.8381 11.5886 29.1429 10.8214 29.1429H3.74997C2.98274 29.1429 2.24693 28.8381 1.70441 28.2956C1.1619 27.7531 0.857117 27.0173 0.857117 26.25V19.1786C0.857117 18.4114 1.1619 17.6756 1.70441 17.133C2.24693 16.5905 2.98274 16.2857 3.74997 16.2857H10.8214ZM20.5735 16.2857V20.571H24.8575V24.8576H20.5735V29.1416H16.2857V24.8563H20.571V20.571H16.2857V16.2857H20.5723H20.5735ZM29.1428 24.8563V29.1429H24.8575V24.8576H29.1428V24.8563ZM10.8214 18.2143H3.74997C3.49423 18.2143 3.24896 18.3159 3.06812 18.4968C2.88728 18.6776 2.78569 18.9229 2.78569 19.1786V26.25C2.78569 26.7823 3.21769 27.2143 3.74997 27.2143H10.8214C11.0771 27.2143 11.3224 27.1127 11.5033 26.9319C11.6841 26.751 11.7857 26.5058 11.7857 26.25V19.1786C11.7857 18.9229 11.6841 18.6776 11.5033 18.4968C11.3224 18.3159 11.0771 18.2143 10.8214 18.2143ZM9.21426 20.7857V24.6429H5.35712V20.7857H9.21426ZM29.1428 16.2857V20.571H24.8575V16.2857H29.1428ZM10.8214 0.857178C11.5886 0.857178 12.3244 1.16196 12.867 1.70448C13.4095 2.24699 13.7143 2.9828 13.7143 3.75003V10.8215C13.7143 11.5887 13.4095 12.3245 12.867 12.867C12.3244 13.4095 11.5886 13.7143 10.8214 13.7143H3.74997C2.98274 13.7143 2.24693 13.4095 1.70441 12.867C1.1619 12.3245 0.857117 11.5887 0.857117 10.8215V3.75003C0.857117 2.9828 1.1619 2.24699 1.70441 1.70448C2.24693 1.16196 2.98274 0.857178 3.74997 0.857178H10.8214ZM26.25 0.857178C27.0172 0.857178 27.753 1.16196 28.2955 1.70448C28.838 2.24699 29.1428 2.9828 29.1428 3.75003V10.8215C29.1428 11.5887 28.838 12.3245 28.2955 12.867C27.753 13.4095 27.0172 13.7143 26.25 13.7143H19.1785C18.4113 13.7143 17.6755 13.4095 17.133 12.867C16.5905 12.3245 16.2857 11.5887 16.2857 10.8215V3.75003C16.2857 2.9828 16.5905 2.24699 17.133 1.70448C17.6755 1.16196 18.4113 0.857178 19.1785 0.857178H26.25ZM10.8214 2.78575H3.74997C3.49423 2.78575 3.24896 2.88734 3.06812 3.06818C2.88728 3.24902 2.78569 3.49429 2.78569 3.75003V10.8215C2.78569 11.3537 3.21769 11.7857 3.74997 11.7857H10.8214C11.0771 11.7857 11.3224 11.6842 11.5033 11.5033C11.6841 11.3225 11.7857 11.0772 11.7857 10.8215V3.75003C11.7857 3.49429 11.6841 3.24902 11.5033 3.06818C11.3224 2.88734 11.0771 2.78575 10.8214 2.78575ZM26.25 2.78575H19.1785C18.9228 2.78575 18.6775 2.88734 18.4967 3.06818C18.3159 3.24902 18.2143 3.49429 18.2143 3.75003V10.8215C18.2143 11.3537 18.6463 11.7857 19.1785 11.7857H26.25C26.5057 11.7857 26.751 11.6842 26.9318 11.5033C27.1127 11.3225 27.2143 11.0772 27.2143 10.8215V3.75003C27.2143 3.49429 27.1127 3.24902 26.9318 3.06818C26.751 2.88734 26.5057 2.78575 26.25 2.78575ZM9.21426 5.35718V9.21432H5.35712V5.35718H9.21426ZM24.6428 5.35718V9.21432H20.7857V5.35718H24.6428Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function ThreatIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 46 46" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M23.1875 0.6875C18.7374 0.6875 14.3873 2.0071 10.6872 4.47943C6.98706 6.95176 4.10318 10.4658 2.40021 14.5771C0.697234 18.6885 0.251659 23.2125 1.11983 27.577C1.98799 31.9416 4.13091 35.9507 7.27759 39.0974C10.4243 42.2441 14.4334 44.387 18.798 45.2552C23.1625 46.1233 27.6865 45.6777 31.7979 43.9748C35.9092 42.2718 39.4232 39.3879 41.8955 35.6878C44.3679 31.9877 45.6875 27.6376 45.6875 23.1875C45.6807 17.2222 43.308 11.5032 39.0899 7.28506C34.8718 3.06695 29.1528 0.694257 23.1875 0.6875ZM21.4567 12.8029C21.4567 12.3439 21.6391 11.9036 21.9637 11.579C22.2882 11.2545 22.7285 11.0721 23.1875 11.0721C23.6465 11.0721 24.0867 11.2545 24.4113 11.579C24.7359 11.9036 24.9183 12.3439 24.9183 12.8029V24.9183C24.9183 25.3773 24.7359 25.8175 24.4113 26.1421C24.0867 26.4667 23.6465 26.649 23.1875 26.649C22.7285 26.649 22.2882 26.4667 21.9637 26.1421C21.6391 25.8175 21.4567 25.3773 21.4567 24.9183V12.8029ZM23.1875 35.3029C22.674 35.3029 22.1721 35.1506 21.7451 34.8653C21.3182 34.5801 20.9855 34.1746 20.789 33.7002C20.5925 33.2258 20.541 32.7038 20.6412 32.2002C20.7414 31.6966 20.9887 31.234 21.3517 30.871C21.7148 30.5079 22.1774 30.2606 22.681 30.1605C23.1846 30.0603 23.7066 30.1117 24.181 30.3082C24.6554 30.5047 25.0608 30.8374 25.3461 31.2644C25.6314 31.6913 25.7836 32.1933 25.7836 32.7067C25.7836 33.3953 25.5101 34.0556 25.0232 34.5425C24.5364 35.0294 23.876 35.3029 23.1875 35.3029Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function IPIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 16 16" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M10.6667 7.33333H9.33333V6H10.6667V7.33333ZM2 3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333ZM6.66667 4.66667H5.33333V11.3333H6.66667V4.66667ZM8 11.3333H9.33333V8.66667H10.6667C11.0203 8.66667 11.3594 8.52619 11.6095 8.27614C11.8595 8.02609 12 7.68696 12 7.33333V6C12 5.64638 11.8595 5.30724 11.6095 5.05719C11.3594 4.80714 11.0203 4.66667 10.6667 4.66667H8V11.3333Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function ToggleOnIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 31 31" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M20.15 4.64999H10.85C9.42516 4.64999 8.01427 4.93064 6.69788 5.4759C5.3815 6.02116 4.18541 6.82037 3.17789 7.82789C2.17038 8.8354 1.37117 10.0315 0.825907 11.3479C0.280644 12.6643 0 14.0752 0 15.5C0 16.9248 0.280644 18.3357 0.825907 19.6521C1.37117 20.9685 2.17038 22.1646 3.17789 23.1721C4.18541 24.1796 5.3815 24.9788 6.69788 25.5241C8.01427 26.0694 9.42516 26.35 10.85 26.35H20.15C21.5748 26.35 22.9857 26.0694 24.3021 25.5241C25.6185 24.9788 26.8146 24.1796 27.8221 23.1721C28.8296 22.1646 29.6288 20.9685 30.1741 19.6521C30.7194 18.3357 31 16.9248 31 15.5C31 14.0752 30.7194 12.6643 30.1741 11.3479C29.6288 10.0315 28.8296 8.8354 27.8221 7.82789C26.8146 6.82037 25.6185 6.02116 24.3021 5.4759C22.9857 4.93064 21.5748 4.64999 20.15 4.64999ZM20.15 23.25C18.0944 23.2498 16.123 22.433 14.6696 20.9793C13.2162 19.5256 12.3998 17.5541 12.4 15.4984C12.4002 13.4428 13.217 11.4715 14.6707 10.018C16.1244 8.56464 18.0959 7.74824 20.1516 7.74844C21.1694 7.74855 22.1773 7.94913 23.1176 8.33873C24.0579 8.72834 24.9123 9.29934 25.6319 10.0191C26.3516 10.7389 26.9224 11.5934 27.3119 12.5338C27.7013 13.4742 27.9016 14.4821 27.9015 15.5C27.9014 16.5178 27.7009 17.5257 27.3113 18.466C26.9217 19.4064 26.3506 20.2607 25.6309 20.9804C24.9111 21.7 24.0566 22.2709 23.1162 22.6603C22.1757 23.0497 21.1678 23.2501 20.15 23.25Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function ToggleOffIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 31 31" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M10.85 26.35H20.15C21.5748 26.35 22.9857 26.0693 24.3021 25.5241C25.6185 24.9788 26.8146 24.1796 27.8221 23.1721C28.8296 22.1646 29.6288 20.9685 30.1741 19.6521C30.7194 18.3357 31 16.9248 31 15.5C31 14.0751 30.7194 12.6643 30.1741 11.3479C29.6288 10.0315 28.8296 8.8354 27.8221 7.82788C26.8146 6.82037 25.6185 6.02116 24.3021 5.4759C22.9857 4.93063 21.5748 4.64999 20.15 4.64999L10.85 4.64999C9.42516 4.64999 8.01427 4.93063 6.69789 5.4759C5.3815 6.02116 4.18541 6.82037 3.17789 7.82788C2.17038 8.8354 1.37117 10.0315 0.825907 11.3479C0.280643 12.6643 1.90735e-06 14.0751 0 15.5C1.90735e-06 16.9248 0.280643 18.3357 0.825907 19.6521C1.37117 20.9685 2.17038 22.1646 3.17789 23.1721C4.18541 24.1796 5.3815 24.9788 6.69789 25.5241C8.01427 26.0693 9.42516 26.35 10.85 26.35ZM10.85 7.74999C12.9056 7.7502 14.877 8.56699 16.3304 10.0207C17.7838 11.4744 18.6002 13.4459 18.6 15.5015C18.5998 17.5572 17.783 19.5285 16.3293 20.9819C14.8756 22.4353 12.9041 23.2517 10.8484 23.2515C9.8306 23.2514 8.82274 23.0509 7.88242 22.6613C6.94209 22.2716 6.08771 21.7006 5.36805 20.9808C4.6484 20.261 4.07757 19.4065 3.68815 18.4661C3.29873 17.5257 3.09835 16.5178 3.09845 15.5C3.09855 14.4821 3.29913 13.4743 3.68874 12.534C4.07835 11.5936 4.64935 10.7392 5.36915 10.0196C6.08895 9.29994 6.94344 8.7291 7.88385 8.33969C8.82425 7.95027 9.83216 7.74989 10.85 7.74999Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function UserIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 70 70" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M35 17.5C32.8368 17.5 30.7221 18.1415 28.9235 19.3433C27.1248 20.5451 25.7229 22.2533 24.8951 24.2519C24.0672 26.2505 23.8506 28.4496 24.2727 30.5713C24.6947 32.693 25.7364 34.6418 27.266 36.1715C28.7957 37.7011 30.7445 38.7428 32.8662 39.1648C34.9879 39.5869 37.187 39.3703 39.1856 38.5424C41.1842 37.7146 42.8924 36.3127 44.0942 34.5141C45.296 32.7154 45.9375 30.6007 45.9375 28.4375C45.9375 25.5367 44.7852 22.7547 42.734 20.7035C40.6828 18.6523 37.9008 17.5 35 17.5Z"
            fill={color}
          />
          <Path
            d="M35 4.375C28.943 4.375 23.0219 6.17113 17.9857 9.53624C12.9494 12.9014 9.02414 17.6843 6.7062 23.2803C4.38827 28.8763 3.78179 35.034 4.96346 40.9746C6.14514 46.9153 9.06188 52.3722 13.3449 56.6551C17.6279 60.9381 23.0847 63.8549 29.0254 65.0365C34.966 66.2182 41.1237 65.6117 46.7197 63.2938C52.3157 60.9759 57.0987 57.0506 60.4638 52.0143C63.8289 46.9781 65.625 41.0571 65.625 35C65.6157 26.8806 62.3862 19.0964 56.6449 13.3551C50.9036 7.61379 43.1194 4.38426 35 4.375ZM52.4825 54.5256C52.4389 51.6564 51.2699 48.919 49.2273 46.9035C47.1847 44.8879 44.4321 43.7554 41.5625 43.75H28.4375C25.5679 43.7554 22.8153 44.8879 20.7727 46.9035C18.7301 48.919 17.5611 51.6564 17.5175 54.5256C13.5506 50.9835 10.7532 46.32 9.49559 41.1527C8.238 35.9854 8.57961 30.5579 10.4752 25.5891C12.3707 20.6202 15.7308 16.3443 20.1105 13.3275C24.4902 10.3107 29.6829 8.69537 35.0011 8.69537C40.3193 8.69537 45.512 10.3107 49.8917 13.3275C54.2714 16.3443 57.6315 20.6202 59.5271 25.5891C61.4226 30.5579 61.7642 35.9854 60.5066 41.1527C59.249 46.32 56.4516 50.9835 52.4847 54.5256H52.4825Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function RefreshIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 20 20" size={iconSize}>
        <G
          fillRule="nonzero"
          stroke={color}
          strokeWidth={2}
          fill="none"
          strokeMiterlimit="10"
          strokeLinecap="round"
        >
          <Path d="M12.5 5.70312C12.5 5.70312 13.4516 5.23438 10 5.23438C8.76387 5.23438 7.55549 5.60093 6.52769 6.28769C5.49988 6.97445 4.6988 7.95057 4.22576 9.0926C3.75271 10.2346 3.62894 11.4913 3.87009 12.7037C4.11125 13.9161 4.70651 15.0297 5.58058 15.9038C6.45466 16.7779 7.56831 17.3731 8.78069 17.6143C9.99307 17.8554 11.2497 17.7317 12.3918 17.2586C13.5338 16.7856 14.5099 15.9845 15.1967 14.9567C15.8834 13.9289 16.25 12.7205 16.25 11.4844" />
          <Path d="M10 2.26562L13.125 5.39062L10 8.51562" />
        </G>
      </Icon>
    </Center>
  );
}

export function ChevronRightIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 23 23" size={iconSize}>
        <G
          fillRule="nonzero"
          stroke={color}
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <Path
            // d="M1.33337 1.16666L9.66671 9.49999L1.33337 17.8333"
            d="M8 4L15 11.5L8 19"
            fill="none"
          />
        </G>
      </Icon>
    </Center>
  );
}

export function ChevronDownIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 23 23" size={iconSize}>
        <G fillRule="nonzero" stroke={color} strokeWidth={2}>
          <Path
            d="M19.6823 8.73106C20.0861 8.35422 20.1079 7.72143 19.7311 7.31768C19.3542 6.91393 18.7214 6.89211 18.3177 7.26895L19.6823 8.73106ZM11.5 15L10.8177 15.7311C11.2019 16.0896 11.7981 16.0896 12.1823 15.7311L11.5 15ZM4.68232 7.26894C4.27857 6.89211 3.64578 6.91393 3.26894 7.31768C2.89211 7.72143 2.91393 8.35422 3.31768 8.73106L4.68232 7.26894ZM18.3177 7.26895L10.8177 14.2689L12.1823 15.7311L19.6823 8.73106L18.3177 7.26895ZM12.1823 14.2689L4.68232 7.26894L3.31768 8.73106L10.8177 15.7311L12.1823 14.2689Z"
            fill="none"
          />
        </G>
      </Icon>
    </Center>
  );
}

export function PremiumPlusIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 41 8" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Circle cx="5.5" cy="5.5" r="5.5" fill={color} />
          <Circle cx="20" cy="5.5" r="5.5" fill={color} />
          <Circle cx="34" cy="5.5" r="5.5" fill={color} />
        </G>
      </Icon>
    </Center>
  );
}

export function PremiumIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 41 8" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Circle cx="5.5" cy="5.5" r="5.5" fill={color} />
          <Circle cx="20" cy="5.5" r="5.5" fill={color} />
          <Circle cx="34" cy="5.5" r="5" stroke={color} />
        </G>
      </Icon>
    </Center>
  );
}

export function StandardIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 41 8" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Circle cx="6" cy="5.5" r="5.5" fill={color} />
          <Circle cx="20" cy="5.5" r="5.5" stroke={color} />
          <Circle cx="34" cy="5.5" r="5.5" stroke={color} />
        </G>
      </Icon>
    </Center>
  );
}

export function StarterIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 41 8" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Circle cx="6" cy="5.5" r="5.5" stroke={color} />
          <Circle cx="20" cy="5.5" r="5.5" stroke={color} />
          <Circle cx="34" cy="5.5" r="5.5" stroke={color} />
        </G>
      </Icon>
    </Center>
  );
}

export function AlertIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 15 15" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M7.5 0C6.01664 0 4.56659 0.439867 3.33323 1.26398C2.09986 2.08809 1.13856 3.25943 0.570907 4.62987C0.00324963 6.00032 -0.145275 7.50832 0.144114 8.96318C0.433503 10.418 1.14781 11.7544 2.1967 12.8033C3.2456 13.8522 4.58197 14.5665 6.03682 14.8559C7.49168 15.1453 8.99968 14.9968 10.3701 14.4291C11.7406 13.8614 12.9119 12.9001 13.736 11.6668C14.5601 10.4334 15 8.98336 15 7.5C14.9977 5.51157 14.2068 3.60522 12.8008 2.19919C11.3948 0.793152 9.48843 0.00225227 7.5 0V0ZM6.92308 4.03846C6.92308 3.88545 6.98386 3.73871 7.09206 3.63051C7.20025 3.52232 7.34699 3.46154 7.5 3.46154C7.65301 3.46154 7.79975 3.52232 7.90795 3.63051C8.01614 3.73871 8.07692 3.88545 8.07692 4.03846V8.07692C8.07692 8.22993 8.01614 8.37667 7.90795 8.48487C7.79975 8.59306 7.65301 8.65384 7.5 8.65384C7.34699 8.65384 7.20025 8.59306 7.09206 8.48487C6.98386 8.37667 6.92308 8.22993 6.92308 8.07692V4.03846ZM7.5 11.5385C7.32884 11.5385 7.16153 11.4877 7.01922 11.3926C6.87691 11.2975 6.76599 11.1624 6.70049 11.0042C6.63499 10.8461 6.61785 10.6721 6.65125 10.5042C6.68464 10.3364 6.76706 10.1822 6.88808 10.0612C7.00911 9.94013 7.16331 9.85771 7.33117 9.82432C7.49904 9.79093 7.67304 9.80807 7.83117 9.87356C7.9893 9.93906 8.12445 10.05 8.21954 10.1923C8.31463 10.3346 8.36539 10.5019 8.36539 10.6731C8.36539 10.9026 8.27421 11.1227 8.11192 11.285C7.94963 11.4473 7.72952 11.5385 7.5 11.5385Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function SignOutIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 19 15" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M0.75 2.25C0.75 1.78587 0.934374 1.34075 1.26256 1.01256C1.59075 0.684374 2.03587 0.5 2.5 0.5H10.375C10.8391 0.5 11.2842 0.684374 11.6124 1.01256C11.9406 1.34075 12.125 1.78587 12.125 2.25V4C12.125 4.23206 12.0328 4.45462 11.8687 4.61872C11.7046 4.78281 11.4821 4.875 11.25 4.875C11.0179 4.875 10.7954 4.78281 10.6313 4.61872C10.4672 4.45462 10.375 4.23206 10.375 4V2.25H2.5V12.75H10.375V11C10.375 10.7679 10.4672 10.5454 10.6313 10.3813C10.7954 10.2172 11.0179 10.125 11.25 10.125C11.4821 10.125 11.7046 10.2172 11.8687 10.3813C12.0328 10.5454 12.125 10.7679 12.125 11V12.75C12.125 13.2141 11.9406 13.6592 11.6124 13.9874C11.2842 14.3156 10.8391 14.5 10.375 14.5H2.5C2.03587 14.5 1.59075 14.3156 1.26256 13.9874C0.934374 13.6592 0.75 13.2141 0.75 12.75V2.25ZM14.1314 4.25638C14.2955 4.09234 14.518 4.00019 14.75 4.00019C14.982 4.00019 15.2045 4.09234 15.3686 4.25638L17.9936 6.88138C18.1577 7.04546 18.2498 7.26798 18.2498 7.5C18.2498 7.73202 18.1577 7.95454 17.9936 8.11862L15.3686 10.7436C15.2036 10.903 14.9826 10.9912 14.7531 10.9892C14.5237 10.9872 14.3043 10.8952 14.142 10.733C13.9798 10.5707 13.8878 10.3513 13.8858 10.1219C13.8838 9.89243 13.972 9.6714 14.1314 9.50638L15.2628 8.375H6.875C6.64294 8.375 6.42038 8.28281 6.25628 8.11872C6.09219 7.95462 6 7.73206 6 7.5C6 7.26794 6.09219 7.04538 6.25628 6.88128C6.42038 6.71719 6.64294 6.625 6.875 6.625H15.2628L14.1314 5.49362C13.9673 5.32954 13.8752 5.10702 13.8752 4.875C13.8752 4.64298 13.9673 4.42046 14.1314 4.25638V4.25638Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function ChartIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon
        viewBox="0 0 65 65"
        size={iconSize}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <G fillRule="nonzero" stroke="none" strokeWidth={4} fill="none">
          <Path d="M2.125 2.125V62.875H62.875" stroke={color} />
          <Path
            d="M15.625 49.375L29.125 22.375L46 37.5625L62.875 2.125"
            stroke={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function CTSLogoIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 600 180" size={iconSize}>
        <G>
          <Path
            d="M65.0494 180C44.8466 180 28.9108 173.867 17.242 161.6C5.74733 149.156 0 132.178 0 110.667C0 88.9778 5.74733 72 17.242 59.7333C28.9108 47.4667 44.8466 41.3333 65.0494 41.3333C77.2407 41.3333 87.8645 43.6444 96.921 48.2667C104.72 52.2473 110.969 57.6782 115.669 64.5594C117.003 66.5126 116.554 69.1246 114.786 70.6953L102.337 81.7527C99.9541 83.8687 96.2403 83.2208 94.2505 80.7319C91.4932 77.283 88.2035 74.4613 84.3813 72.2667C78.9823 69.0667 73.0608 67.4667 66.6168 67.4667C56.1671 67.4667 47.9815 71.2889 42.06 78.9333C36.1385 86.5778 33.1778 97.1556 33.1778 110.667C33.1778 124.178 36.1385 134.756 42.06 142.4C47.9815 150.044 56.1671 153.867 66.6168 153.867C73.0608 153.867 78.9823 152.267 84.3813 149.067C88.1372 146.717 91.4295 143.808 94.2583 140.34C96.2261 137.927 99.8425 137.366 102.17 139.433L114.786 150.638C116.554 152.209 117.003 154.821 115.669 156.774C110.969 163.655 104.72 169.086 96.921 173.067C87.8645 177.689 77.2407 180 65.0494 180Z"
            fill={color}
          />
          <Path
            d="M195.786 180C182.376 180 171.926 176.267 164.437 168.8C156.948 161.333 153.204 150.844 153.204 137.333V74.3333C153.204 71.5719 150.965 69.3333 148.204 69.3333H134.431C131.669 69.3333 129.431 67.0948 129.431 64.3333V49C129.431 46.2386 131.669 44 134.431 44H148.204C150.965 44 153.204 41.7614 153.204 39V13.3332C153.204 11.1189 154.66 9.16842 156.783 8.53927L185.471 0.0376133C185.555 0.0126683 185.643 0 185.73 0C186.234 0 186.643 0.40858 186.643 0.912589V39C186.643 41.7614 188.881 44 191.643 44H219.523C222.284 44 224.523 46.2386 224.523 49V64.3333C224.523 67.0948 222.284 69.3333 219.523 69.3333H191.643C188.881 69.3333 186.643 71.5719 186.643 74.3333V132.267C186.643 139.911 188.385 145.511 191.868 149.067C195.351 152.622 200.663 154.4 207.804 154.4C212.224 154.4 216.46 153.948 220.512 153.045C223.754 152.322 227.097 154.499 227.321 157.814L228.213 171.01C228.351 173.056 227.234 175.003 225.316 175.729C217.797 178.576 207.954 180 195.786 180Z"
            fill={color}
          />
          <Path
            d="M294.46 180C283.139 180 273.125 177.689 264.417 173.067C257.287 169.205 251.92 164.288 248.316 158.317C247.077 156.265 247.803 153.663 249.757 152.275L262.939 142.907C265.196 141.303 268.301 141.87 270.201 143.883C272.736 146.567 275.684 148.828 279.047 150.667C283.923 153.333 288.887 154.667 293.937 154.667C299.859 154.667 304.735 153.156 308.567 150.133C312.399 146.933 314.314 143.022 314.314 138.4C314.314 134.667 312.921 131.733 310.134 129.6C307.348 127.289 301.426 124.356 292.37 120.8C276.521 114.578 265.375 108.267 258.931 101.867C252.487 95.4667 249.265 87.5556 249.265 78.1333C249.265 67.1111 253.619 58.2222 262.327 51.4667C271.209 44.7111 282.965 41.3333 297.595 41.3333C307.348 41.3333 316.143 43.2889 323.98 47.2C330.358 50.2382 335.756 54.3949 340.173 59.67C341.886 61.7158 341.38 64.7345 339.254 66.3473L327.607 75.1833C325.445 76.8239 322.398 76.3983 320.407 74.5529C314.736 69.2954 307.567 66.6667 298.901 66.6667C293.676 66.6667 289.583 67.6444 286.623 69.6C283.836 71.3778 282.443 74.0444 282.443 77.6C282.443 80.0889 283.052 82.1333 284.271 83.7333C285.491 85.3333 287.842 87.0222 291.325 88.8C294.808 90.5778 300.381 92.9778 308.045 96C318.32 100.089 326.244 104.089 331.817 108C337.565 111.733 341.57 115.911 343.835 120.533C346.273 124.978 347.492 130.4 347.492 136.8C347.492 145.333 345.228 152.889 340.7 159.467C336.346 165.867 330.163 170.933 322.152 174.667C314.14 178.222 304.91 180 294.46 180Z"
            fill={color}
          />
          <Path
            d="M477.835 180C469.301 180 461.638 178.222 454.846 174.667C448.053 170.933 442.741 165.867 438.91 159.467C435.078 152.889 433.163 145.6 433.163 137.6C433.163 123.911 438.475 113.422 449.098 106.133C459.722 98.8444 474.874 95.2 494.555 95.2H509.931C512.693 95.2 514.931 92.9614 514.931 90.2V89.6C514.931 82.4889 512.842 77.0667 508.662 73.3333C504.656 69.4222 498.909 67.4667 491.42 67.4667C483.582 67.4667 476.093 68.8889 468.953 71.7333C463.947 73.7273 459.583 76.2456 455.861 79.288C453.423 81.2814 449.703 81.1109 447.827 78.5806L439.427 67.2493C437.934 65.2364 438.151 62.4151 440.048 60.7785C446.468 55.2411 453.839 50.8038 462.161 47.4667C471.914 43.3778 482.015 41.3333 492.465 41.3333C509.881 41.3333 523.552 45.5111 533.48 53.8667C543.407 62.2222 548.37 73.7778 548.37 88.5333V149.333C548.37 153.422 548.632 158.222 549.154 163.733C549.494 166.418 549.854 168.87 550.234 171.091C550.782 174.287 548.376 177.333 545.133 177.333H525.212C523.247 177.333 521.437 176.193 520.762 174.348C520.304 173.093 519.928 171.866 519.634 170.667C519.127 168.423 518.701 165.426 518.358 161.674C518.341 161.481 518.179 161.333 517.985 161.333C517.871 161.333 517.763 161.386 517.692 161.475C507.777 173.825 494.491 180 477.835 180ZM485.934 154.4C494.293 154.4 501.173 152.267 506.572 148C512.145 143.556 514.931 137.956 514.931 131.2V122.867C514.931 120.105 512.693 117.867 509.931 117.867H493.51C484.627 117.867 477.748 119.556 472.871 122.933C468.169 126.311 465.818 131.2 465.818 137.6C465.818 142.933 467.56 147.111 471.043 150.133C474.7 152.978 479.664 154.4 485.934 154.4Z"
            fill={color}
          />
          <Path
            d="M566.822 49C566.822 46.2386 569.061 44 571.822 44H595C597.761 44 600 46.2386 600 49V172.333C600 175.095 597.761 177.333 595 177.333H571.822C569.061 177.333 566.822 175.095 566.822 172.333V49Z"
            fill={color}
          />
          <Path
            d="M392.248 137.867C385.804 137.867 380.667 136.089 376.835 132.533C373.004 128.8 371.088 123.911 371.088 117.867C371.088 111.822 373.004 107.022 376.835 103.467C380.667 99.7333 385.804 97.8667 392.248 97.8667C398.692 97.8667 403.83 99.7333 407.662 103.467C411.667 107.022 413.67 111.822 413.67 117.867C413.67 123.911 411.755 128.8 407.923 132.533C404.091 136.089 398.867 137.867 392.248 137.867Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function AddUserIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 22 22" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M1.83333 8.24999C1.83346 7.31456 2.07216 6.39461 2.52689 5.57713C2.98161 4.75966 3.63731 4.07166 4.43201 3.57821C5.22671 3.08476 6.13413 2.80214 7.06848 2.7571C8.00283 2.71205 8.93324 2.90606 9.77172 3.32078C10.6102 3.7355 11.329 4.35722 11.8603 5.12716C12.3916 5.89711 12.7176 6.78983 12.8078 7.72091C12.8979 8.652 12.749 9.59068 12.3753 10.4482C12.0015 11.3057 11.4152 12.0538 10.6718 12.6216C13.0038 13.6647 14.6667 15.774 14.6667 18.3333C14.6667 18.5764 14.5701 18.8096 14.3982 18.9815C14.2263 19.1534 13.9931 19.25 13.75 19.25H0.916667C0.673552 19.25 0.440394 19.1534 0.268485 18.9815C0.0965771 18.8096 0 18.5764 0 18.3333C0 15.774 1.66283 13.6647 3.99483 12.6216C3.32214 12.1086 2.77706 11.4472 2.40212 10.6889C2.02718 9.93062 1.83252 9.09593 1.83333 8.24999V8.24999ZM19.25 8.24999C19.25 8.00688 19.1534 7.77372 18.9815 7.60181C18.8096 7.42991 18.5764 7.33333 18.3333 7.33333C18.0902 7.33333 17.8571 7.42991 17.6852 7.60181C17.5132 7.77372 17.4167 8.00688 17.4167 8.24999V10.0833H15.5833C15.3402 10.0833 15.1071 10.1799 14.9352 10.3518C14.7632 10.5237 14.6667 10.7569 14.6667 11C14.6667 11.2431 14.7632 11.4763 14.9352 11.6482C15.1071 11.8201 15.3402 11.9167 15.5833 11.9167H17.4167V13.75C17.4167 13.9931 17.5132 14.2263 17.6852 14.3982C17.8571 14.5701 18.0902 14.6667 18.3333 14.6667C18.5764 14.6667 18.8096 14.5701 18.9815 14.3982C19.1534 14.2263 19.25 13.9931 19.25 13.75V11.9167H21.0833C21.3264 11.9167 21.5596 11.8201 21.7315 11.6482C21.9034 11.4763 22 11.2431 22 11C22 10.7569 21.9034 10.5237 21.7315 10.3518C21.5596 10.1799 21.3264 10.0833 21.0833 10.0833H19.25V8.24999Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function PasswordIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 24 24" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M12.65 10C12.2381 8.83048 11.4733 7.81762 10.4613 7.10116C9.44934 6.3847 8.23994 5.99995 7 6C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18C8.23994 18 9.44934 17.6153 10.4613 16.8988C11.4733 16.1824 12.2381 15.1695 12.65 14H17V18H21V14H23V10H12.65ZM7 14C5.9 14 5 13.1 5 12C5 10.9 5.9 10 7 10C8.1 10 9 10.9 9 12C9 13.1 8.1 14 7 14Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function LanguageIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 30 30" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M12.1958 18.5704V18.0704H11.6958H3.10889V3.10869H17.8045V11.4296V11.9296H18.3045H26.8915V26.8913H12.1958V18.5704ZM9.01963 12.1897H8.66309L8.54692 12.5268L8.24147 13.4131H7.54851L9.79642 6.88909H11.1172L12.7375 11.5925L12.8537 11.9296H13.2103H16.6524H17.1524V11.4296V4.48887C17.1524 4.10227 16.839 3.78887 16.4524 3.78887H4.46106C4.07446 3.78887 3.76106 4.10227 3.76106 4.48887V16.6902C3.76106 17.0768 4.07446 17.3902 4.46106 17.3902H11.6958H12.1958V16.8902V12.6897V12.1897H11.6958H9.01963ZM11.3149 11.5096H12.016L11.7876 10.8467L10.9294 8.35594L10.4567 6.98394L9.98399 8.35594L9.12579 10.8467L8.89739 11.5096H9.59851H11.3149ZM26.2393 13.3098C26.2393 12.9232 25.9259 12.6098 25.5393 12.6098H13.548C13.1614 12.6098 12.848 12.9232 12.848 13.3098V25.5111C12.848 25.8977 13.1614 26.2111 13.548 26.2111H25.5393C25.9259 26.2111 26.2393 25.8977 26.2393 25.5111V13.3098Z"
            fill={color}
            stroke={color}
          />
          <Path
            d="M17.6867 20.7626C17.853 21.003 18.0362 21.2337 18.235 21.4533C17.6046 21.7593 16.8886 21.9125 16.0871 21.913V23.4783C17.3991 23.4783 18.5714 23.1648 19.5654 22.5575C20.5594 23.1648 21.7316 23.4783 23.0436 23.4783V21.913C22.2438 21.913 21.5279 21.7597 20.8958 21.4529C21.0946 21.2335 21.2778 21.0029 21.4441 20.7626C21.9453 20.0292 22.3139 19.2288 22.5361 18.3913H23.4784V16.8261H20.435V15.6522H18.6958V16.8261H15.6523V18.3913H16.5946C16.8168 19.2288 17.1854 20.0292 17.6867 20.7626ZM20.7355 18.3913C20.5556 18.933 20.298 19.4513 19.9692 19.933C19.8464 20.1107 19.7115 20.2813 19.5654 20.4441C19.4299 20.2934 19.3042 20.1357 19.1888 19.972C18.8466 19.4795 18.5797 18.9479 18.3951 18.3913H20.7355Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function ThemeIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 30 30" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M14.5002 24.913V25.413H15.0002C17.7619 25.413 20.4105 24.316 22.3633 22.3631C24.3161 20.4103 25.4132 17.7617 25.4132 15C25.4132 12.2383 24.3161 9.58968 22.3633 7.63686C20.4105 5.68403 17.7619 4.58695 15.0002 4.58695H14.5002V5.08695V24.913ZM26.8915 15C26.8915 21.5676 21.5678 26.8913 15.0002 26.8913C8.43262 26.8913 3.10889 21.5676 3.10889 15C3.10889 8.43242 8.43262 3.10869 15.0002 3.10869C21.5678 3.10869 26.8915 8.43242 26.8915 15Z"
            fill={color}
            stroke={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function PhoneIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 30 30" size={iconSize}>
        <G fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
          <Path
            d="M8.32617 5.70652C8.32617 5.00571 8.58441 4.34058 9.03346 3.85581C9.48131 3.37233 10.0802 3.1087 10.6957 3.1087H19.3044C19.92 3.1087 20.5189 3.37233 20.9667 3.85581C21.4158 4.34058 21.674 5.00571 21.674 5.70652V24.2935C21.674 24.9943 21.4158 25.6594 20.9667 26.1442C20.5189 26.6277 19.92 26.8913 19.3044 26.8913H10.6957C10.0802 26.8913 9.48131 26.6277 9.03346 26.1442C8.58441 25.6594 8.32617 24.9943 8.32617 24.2935V5.70652ZM16.9349 22.7446C16.9349 22.213 16.7396 21.6962 16.3814 21.3095C16.0221 20.9216 15.5261 20.6957 15.0001 20.6957C14.4741 20.6957 13.9781 20.9216 13.6187 21.3095C13.2606 21.6962 13.0653 22.213 13.0653 22.7446C13.0653 23.2761 13.2606 23.7929 13.6187 24.1796C13.9781 24.5675 14.4741 24.7935 15.0001 24.7935C15.5261 24.7935 16.0221 24.5675 16.3814 24.1796C16.7396 23.7929 16.9349 23.2761 16.9349 22.7446Z"
            fill={color}
            stroke={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function SupportIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 30 30" size={iconSize}>
        <G
          stroke="none"
          strokeWidth={1}
          fill="none"
          fillRule="evenodd"
          clipRule="evenodd"
        >
          <Path
            d="M15.0002 27.3913C21.8437 27.3913 27.3915 21.8435 27.3915 15C27.3915 8.15647 21.8437 2.60869 15.0002 2.60869C8.15666 2.60869 2.60889 8.15647 2.60889 15C2.60889 21.8435 8.15666 27.3913 15.0002 27.3913ZM13.3874 18.689C13.3874 19.0663 13.4279 19.4001 13.5088 19.6904H15.0862C15.0322 19.4727 15.0053 19.1679 15.0053 18.7761C15.0053 18.152 15.14 17.5933 15.4097 17.0998C15.6793 16.5919 16.0837 15.9896 16.623 15.293C17.1758 14.5383 17.5869 13.907 17.8566 13.399C18.1262 12.8911 18.2611 12.3178 18.2611 11.6793C18.2611 10.4747 17.9173 9.53135 17.2298 8.84924C16.5421 8.16713 15.5715 7.82608 14.3176 7.82608C13.4548 7.82608 12.6864 8.01474 12.0124 8.39207C11.3518 8.76941 10.8259 9.29914 10.435 9.98125L11.4056 11.1568C11.7158 10.5908 12.1066 10.1481 12.5786 9.82886C13.0639 9.50957 13.583 9.34993 14.1356 9.34993C15.6726 9.34993 16.441 10.1699 16.441 11.8099C16.441 12.3323 16.3197 12.8258 16.077 13.2902C15.8479 13.7546 15.4839 14.3424 14.9851 15.0535C14.4593 15.8082 14.0616 16.4467 13.7919 16.9692C13.5223 17.4917 13.3874 18.0649 13.3874 18.689ZM13.4077 23.1082C13.6503 23.3549 13.9672 23.4783 14.3582 23.4783C14.7491 23.4783 15.0591 23.3549 15.2884 23.1082C15.531 22.8614 15.6524 22.5349 15.6524 22.1285C15.6524 21.7222 15.531 21.3956 15.2884 21.1489C15.0591 20.9022 14.7491 20.7789 14.3582 20.7789C13.9672 20.7789 13.6503 20.9022 13.4077 21.1489C13.1785 21.3956 13.0639 21.7222 13.0639 22.1285C13.0639 22.5349 13.1785 22.8614 13.4077 23.1082Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function UserGroupIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 23 23" size={iconSize}>
        <G
          stroke="none"
          strokeWidth={1}
          fill="none"
          fillRule="evenodd"
          clipRule="evenodd"
        >
          <Path
            d="M14.73 7.08001C14.73 7.93665 14.3897 8.75822 13.784 9.36396C13.1782 9.9697 12.3567 10.31 11.5 10.31C10.6434 10.31 9.82181 9.9697 9.21606 9.36396C8.61032 8.75822 8.27002 7.93665 8.27002 7.08001C8.27002 6.22336 8.61032 5.40179 9.21606 4.79605C9.82181 4.19031 10.6434 3.85001 11.5 3.85001C12.3567 3.85001 13.1782 4.19031 13.784 4.79605C14.3897 5.40179 14.73 6.22336 14.73 7.08001Z"
            fill={color}
          />
          <Path
            d="M20.1133 9.23334C20.1133 9.80443 19.8864 10.3521 19.4826 10.756C19.0788 11.1598 18.5311 11.3867 17.96 11.3867C17.3889 11.3867 16.8412 11.1598 16.4373 10.756C16.0335 10.3521 15.8066 9.80443 15.8066 9.23334C15.8066 8.66224 16.0335 8.11453 16.4373 7.7107C16.8412 7.30687 17.3889 7.08 17.96 7.08C18.5311 7.08 19.0788 7.30687 19.4826 7.7107C19.8864 8.11453 20.1133 8.66224 20.1133 9.23334Z"
            fill={color}
          />
          <Path
            d="M15.8067 16.77C15.8067 15.6278 15.353 14.5324 14.5453 13.7247C13.7376 12.9171 12.6422 12.4633 11.5 12.4633C10.3578 12.4633 9.26241 12.9171 8.45475 13.7247C7.6471 14.5324 7.19336 15.6278 7.19336 16.77V20H15.8067V16.77Z"
            fill={color}
          />
          <Path
            d="M7.19339 9.23334C7.19339 9.80443 6.96652 10.3521 6.56269 10.756C6.15886 11.1598 5.61115 11.3867 5.04005 11.3867C4.46895 11.3867 3.92124 11.1598 3.51742 10.756C3.11359 10.3521 2.88672 9.80443 2.88672 9.23334C2.88672 8.66224 3.11359 8.11453 3.51742 7.7107C3.92124 7.30687 4.46895 7.08 5.04005 7.08C5.61115 7.08 6.15886 7.30687 6.56269 7.7107C6.96652 8.11453 7.19339 8.66224 7.19339 9.23334Z"
            fill={color}
          />
          <Path
            d="M17.9601 20V16.77C17.9616 15.6753 17.6837 14.5984 17.1526 13.6412C17.6299 13.5191 18.1289 13.5075 18.6113 13.6075C19.0938 13.7075 19.547 13.9164 19.9365 14.2182C20.326 14.52 20.6414 14.9068 20.8586 15.349C21.0759 15.7913 21.1892 16.2773 21.1901 16.77V20H17.9601Z"
            fill={color}
          />
          <Path
            d="M5.84756 13.6412C5.31649 14.5984 5.03855 15.6753 5.04006 16.77V20H1.81006V16.77C1.80985 16.2769 1.92253 15.7904 2.13946 15.3476C2.35639 14.9048 2.67182 14.5176 3.06156 14.2155C3.4513 13.9135 3.90502 13.7047 4.38793 13.6052C4.87085 13.5056 5.37015 13.5179 5.84756 13.6412Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function PaymentsIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 23 23" size={iconSize}>
        <G
          stroke="none"
          strokeWidth={1}
          fill="none"
          fillRule="evenodd"
          clipRule="evenodd"
        >
          <Path
            d="M17.5455 13.125V6.625C17.5455 5.73125 16.7682 5 15.8182 5H3.72727C2.77727 5 2 5.73125 2 6.625V13.125C2 14.0188 2.77727 14.75 3.72727 14.75H15.8182C16.7682 14.75 17.5455 14.0188 17.5455 13.125ZM9.77273 12.3125C8.33909 12.3125 7.18182 11.2238 7.18182 9.875C7.18182 8.52625 8.33909 7.4375 9.77273 7.4375C11.2064 7.4375 12.3636 8.52625 12.3636 9.875C12.3636 11.2238 11.2064 12.3125 9.77273 12.3125ZM20.1364 7.4375C20.6133 7.4375 21 7.82416 21 8.30114V16.375C21 17.2688 20.2227 18 19.2727 18H5.40341C4.95468 18 4.59091 17.6362 4.59091 17.1875C4.59091 16.7388 4.95468 16.375 5.40341 16.375H18.2727C18.825 16.375 19.2727 15.9273 19.2727 15.375V8.30114C19.2727 7.82416 19.6594 7.4375 20.1364 7.4375Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function NameIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 23 23" size={iconSize}>
        <G
          stroke="none"
          strokeWidth={1}
          fill="none"
          fillRule="evenodd"
          clipRule="evenodd"
        >
          <Path
            d="M9.76136 2C9.60766 2 9.46025 2.06256 9.35156 2.17391C9.24288 2.28526 9.18182 2.43628 9.18182 2.59375C9.18182 2.75122 9.24288 2.90225 9.35156 3.01359C9.46025 3.12494 9.60766 3.1875 9.76136 3.1875H10.9205V19.8125H9.76136C9.60766 19.8125 9.46025 19.8751 9.35156 19.9864C9.24288 20.0978 9.18182 20.2488 9.18182 20.4062C9.18182 20.5637 9.24288 20.7147 9.35156 20.8261C9.46025 20.9374 9.60766 21 9.76136 21H13.2386C13.3923 21 13.5398 20.9374 13.6484 20.8261C13.7571 20.7147 13.8182 20.5637 13.8182 20.4062C13.8182 20.2488 13.7571 20.0978 13.6484 19.9864C13.5398 19.8751 13.3923 19.8125 13.2386 19.8125H12.0795V3.1875H13.2386C13.3923 3.1875 13.5398 3.12494 13.6484 3.01359C13.7571 2.90225 13.8182 2.75122 13.8182 2.59375C13.8182 2.43628 13.7571 2.28526 13.6484 2.17391C13.5398 2.06256 13.3923 2 13.2386 2H9.76136ZM5.51136 5.1825H10.1477V6.37H5.51136C5.15272 6.37 4.80876 6.51596 4.55516 6.77578C4.30156 7.0356 4.15909 7.38798 4.15909 7.75542V15.2763C4.15909 16.041 4.76491 16.6617 5.51136 16.6617H10.1477V17.8492H5.51136C4.84531 17.8492 4.20653 17.5781 3.73556 17.0956C3.26459 16.6131 3 15.9586 3 15.2763V7.75542C3 7.07304 3.26459 6.41861 3.73556 5.93609C4.20653 5.45357 4.84531 5.1825 5.51136 5.1825ZM17.4886 16.6617H12.8523V17.8492H17.4886C18.1547 17.8492 18.7935 17.5781 19.2644 17.0956C19.7354 16.6131 20 15.9586 20 15.2763V7.75542C20 7.07304 19.7354 6.41861 19.2644 5.93609C18.7935 5.45357 18.1547 5.1825 17.4886 5.1825H12.8523V6.37H17.4886C18.2351 6.37 18.8409 6.98988 18.8409 7.75542V15.2763C18.8409 15.6437 18.6984 15.9961 18.4448 16.2559C18.1912 16.5157 17.8473 16.6617 17.4886 16.6617Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}
export function SeenIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 23 23" size={iconSize}>
        <G
          stroke="none"
          strokeWidth={2}
          fill="none"
          fillRule="evenodd"
          clipRule="evenodd"
        >
          <Path
            d="M20.6487 10.6844C21.1171 11.1716 21.1171 11.8292 20.6487 12.3156C19.1732 13.8469 15.6331 17 11.5002 17C7.36716 17 3.82714 13.8469 2.35163 12.3156C2.12372 12.0823 2 11.7954 2 11.5C2 11.2046 2.12372 10.9177 2.35163 10.6844C3.82714 9.15307 7.36716 6 11.5002 6C15.6331 6 19.1732 9.15307 20.6487 10.6844V10.6844Z"
            stroke={color}
          />
          <Path
            d="M11.5 14.375C13.0878 14.375 14.375 13.0878 14.375 11.5C14.375 9.91218 13.0878 8.625 11.5 8.625C9.91218 8.625 8.625 9.91218 8.625 11.5C8.625 13.0878 9.91218 14.375 11.5 14.375Z"
            stroke={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function UnseenIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 23 23" size={iconSize}>
        <G
          stroke="none"
          strokeWidth={2}
          fill="none"
          fillRule="evenodd"
          clipRule="evenodd"
        >
          <Path
            d="M6.25987 16C4.50784 14.9199 3.12142 13.515 2.33799 12.6279C2.11892 12.383 2 12.0818 2 11.7717C2 11.4616 2.11892 11.1604 2.33799 10.9155C3.75575 9.3086 7.15725 6 11.1285 6C12.91 6 14.5756 6.66535 16 7.54506"
            stroke={color}
          />
          <Path
            d="M4 18L19.4435 5M9.79133 16.947C10.418 17.104 11.068 17.185 11.7218 17.1875C15.7583 17.1875 19.2157 13.9269 20.6568 12.3434C20.8794 12.1018 21.0002 11.8048 21 11.499C20.9998 11.1933 20.8787 10.8964 20.6559 10.655C20.1494 10.0988 19.6061 9.56716 19.0285 9.0625M13.7777 9.78319C13.5096 9.55379 13.1903 9.37134 12.8381 9.24636C12.4858 9.12137 12.1077 9.05633 11.7254 9.05498C11.3432 9.05364 10.9644 9.11601 10.6109 9.2385C10.2575 9.361 9.93632 9.54119 9.666 9.76869C9.39568 9.99618 9.18154 10.2665 9.03594 10.564C8.89033 10.8615 8.81615 11.1803 8.81766 11.5021C8.81917 11.8239 8.89635 12.1422 9.04474 12.4387C9.19313 12.7353 9.4098 13.0041 9.68226 13.2298L13.7777 9.78319Z"
            stroke={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function FiltersIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 23 23" size={iconSize}>
        <G
          stroke="none"
          strokeWidth={2}
          fill="none"
          fillRule="evenodd"
          clipRule="evenodd"
          strokeLinecap="round"
        >
          <Path
            d="M20.125 18.2083H8.625M2.875 4.79166H6.70833H2.875ZM20.125 4.79166H10.5417H20.125ZM2.875 11.5H14.375H2.875ZM20.125 11.5H18.2083H20.125ZM2.875 18.2083H4.79167H2.875Z"
            stroke={color}
          />
          <Path
            d="M8.62492 6.70833C9.68347 6.70833 10.5416 5.85021 10.5416 4.79167C10.5416 3.73312 9.68347 2.875 8.62492 2.875C7.56637 2.875 6.70825 3.73312 6.70825 4.79167C6.70825 5.85021 7.56637 6.70833 8.62492 6.70833Z"
            stroke={color}
          />
          <Path
            d="M16.2917 13.4167C17.3502 13.4167 18.2083 12.5586 18.2083 11.5C18.2083 10.4415 17.3502 9.58334 16.2917 9.58334C15.2331 9.58334 14.375 10.4415 14.375 11.5C14.375 12.5586 15.2331 13.4167 16.2917 13.4167Z"
            stroke={color}
          />
          <Path
            d="M6.70841 20.125C7.76696 20.125 8.62508 19.2669 8.62508 18.2084C8.62508 17.1498 7.76696 16.2917 6.70841 16.2917C5.64987 16.2917 4.79175 17.1498 4.79175 18.2084C4.79175 19.2669 5.64987 20.125 6.70841 20.125Z"
            stroke={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function CheckSimpleIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon viewBox="0 0 23 23" size={iconSize}>
        <G>
          <Path
            d="M16.1347 7.31882C16.3421 7.11207 16.618 6.99776 16.9043 7.00003C17.1906 7.0023 17.4649 7.12096 17.6692 7.33098C17.8736 7.541 17.992 7.82594 17.9996 8.12569C18.0072 8.42543 17.9033 8.71653 17.7098 8.93756L11.8363 16.6305C11.7353 16.7444 11.6134 16.8358 11.4779 16.8993C11.3424 16.9627 11.196 16.9969 11.0476 16.9998C10.8992 17.0027 10.7518 16.9742 10.6141 16.916C10.4765 16.8579 10.3514 16.7712 10.2465 16.6613L6.35139 12.5821C6.24292 12.4762 6.15592 12.3485 6.09558 12.2067C6.03523 12.0649 6.00279 11.9118 6.00017 11.7565C5.99756 11.6013 6.02483 11.4471 6.08035 11.3031C6.13588 11.1591 6.21853 11.0283 6.32337 10.9185C6.42821 10.8087 6.55309 10.7222 6.69056 10.664C6.82803 10.6059 6.97528 10.5773 7.12352 10.5801C7.27176 10.5828 7.41796 10.6168 7.55338 10.68C7.68881 10.7432 7.8107 10.8343 7.91177 10.9479L10.9943 14.1746L16.1067 7.35274C16.1159 7.34087 16.1258 7.32954 16.1362 7.31882H16.1347Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function CircleChevronLeftIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon
        viewBox="0 0 23 23"
        size={iconSize}
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <G>
          <Path
            d="M11.5 2C6.25341 2 2 6.25341 2 11.5C2 16.7466 6.25341 21 11.5 21C16.7466 21 21 16.7466 21 11.5C21 6.25341 16.7466 2 11.5 2ZM13.406 8.65605C13.5634 8.49316 13.6504 8.27501 13.6484 8.04856C13.6465 7.82212 13.5557 7.60551 13.3955 7.44538C13.2354 7.28526 13.0188 7.19443 12.7923 7.19246C12.5659 7.1905 12.3477 7.27755 12.1849 7.43486L8.73032 10.8894C8.56841 11.0514 8.47746 11.271 8.47746 11.5C8.47746 11.729 8.56841 11.9486 8.73032 12.1106L12.1849 15.5651C12.3477 15.7225 12.5659 15.8095 12.7923 15.8075C13.0188 15.8056 13.2354 15.7147 13.3955 15.5546C13.5557 15.3945 13.6465 15.1779 13.6484 14.9514C13.6504 14.725 13.5634 14.5068 13.406 14.344L10.5621 11.5L13.406 8.65605Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}

export function CircleChevronRightIcon({ iconSize, color }: IconProps) {
  return (
    <Center>
      <Icon
        viewBox="0 0 23 23"
        size={iconSize}
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <G>
          <Path
            d="M11.5 2C6.25341 2 2 6.25341 2 11.5C2 16.7466 6.25341 21 11.5 21C16.7466 21 21 16.7466 21 11.5C21 6.25341 16.7466 2 11.5 2ZM9.59395 8.65605C9.43664 8.49316 9.34959 8.27501 9.35155 8.04856C9.35352 7.82212 9.44435 7.60551 9.60448 7.44538C9.7646 7.28526 9.98121 7.19443 10.2077 7.19246C10.4341 7.1905 10.6523 7.27755 10.8151 7.43486L14.2697 10.8894C14.4316 11.0514 14.5225 11.271 14.5225 11.5C14.5225 11.729 14.4316 11.9486 14.2697 12.1106L10.8151 15.5651C10.6523 15.7225 10.4341 15.8095 10.2077 15.8075C9.98121 15.8056 9.7646 15.7147 9.60448 15.5546C9.44435 15.3945 9.35352 15.1779 9.35155 14.9514C9.34959 14.725 9.43664 14.5068 9.59395 14.344L12.4379 11.5L9.59395 8.65605Z"
            fill={color}
          />
        </G>
      </Icon>
    </Center>
  );
}
